import { render, staticRenderFns } from "./Retailers.vue?vue&type=template&id=cc68a59c&"
import script from "./Retailers.vue?vue&type=script&lang=js&"
export * from "./Retailers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports